<template>
  <div class="dv-mode-pills flex h-7 rounded-full border border-stroke dark:border-stroke-dark overflow-hidden flex-shrink-0">
    <button
      v-for="(m, i) in options" :key="m.value"
      @click="$emit('update:modelValue', m.value)"
      :class="['flex items-center justify-center px-3 text-xs font-medium transition-colors',
        i > 0 ? 'border-l border-stroke dark:border-stroke-dark' : '',
        modelValue === m.value
          ? 'bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300'
          : 'text-fg-secondary dark:text-fg-secondary-dark hover:bg-surface-muted dark:hover:bg-surface-hover-dark']"
    >{{ m.label }}</button>
  </div>
  <FilterIconDropdown class="dv-mode-select hidden" :icon="CalendarDaysIcon" label="View" panel-class="w-28">
    <template #default="{ close }">
      <FilterOptionList :options="listOptions" hide-clear @toggle="v => { $emit('update:modelValue', v); close() }" />
    </template>
  </FilterIconDropdown>
</template>

<style scoped>
/* Day/Week/Month pill switcher shared by Team Calendar and the admin calendar routes.
   Mirrors CalendarToolbar.vue's .dv-toolbar container-query system: the pills compress
   into an icon-only dropdown (calendar-days heroicon) based on the toolbar's own
   available width, not the page viewport — a sidebar-narrowed toolbar can be tight well
   above the old sm: breakpoint. Sits between CalendarToolbar's Refresh/+New Lesson
   "..." consolidation (820px) and CalendarFilterBar's Teachers/Instrument/Location
   icon-only consolidation (520px). Outside a dv-toolbar container (the admin List
   view's TableToolbar) the query never matches and the pills always show. */
@container dv-toolbar (max-width: 720px) {
  .dv-mode-pills { display: none !important; }
  .dv-mode-select { display: flex !important; }
}
</style>

<script setup>
import { computed } from 'vue'
import { CalendarDaysIcon } from '@heroicons/vue/24/outline'
import FilterOptionList from './FilterOptionList.vue'
import FilterIconDropdown from './FilterIconDropdown.vue'

const props = defineProps({
  options:    { type: Array, required: true },   // [{ value, label }]
  modelValue: { type: String, default: null },
})
defineEmits(['update:modelValue'])

const listOptions = computed(() => props.options.map(m => ({ ...m, active: props.modelValue === m.value })))
</script>
